/**
 * Check if Data Factory user response is of type "Reservert mot nummeropplysning"
 * @param user The data factory response user
 * @returns Is true if user is reserved against directory enquiries
 */
export const isReservedDataFactoryUser = (user) => {
    const fullName = user.names?.[0]?.fullName;
    const IS_RESERVED_STRING = "Reservert mot nummeropplysning";
    return fullName === IS_RESERVED_STRING;
};
